import { ChannelConfig } from "./ChannelConfig"
import { Vector3 } from 'three/src/math/Vector3'

const focusChannel: ChannelConfig = {
    showInChannelList: true,
    passwordProtected: false,
    id: "focus",
    
    tickerSeparator: "by",
    streamURL: "https://memustream.live:8443/focusstream",
    streamURLDev: "https://memustream.live:8443/focusstream",
    metadataURL: "https://memustream.live/memu/focus/focus_ticker.json",
    
    name: "Focus",
    channelListName: "FOCUS",
    urlSlug: "focus",
    attributionDescription: "MEMU channels generate music live using our AI music engine and sounds provided by our collaborators, inputs are fully trackable! If you're interested in creating your own customised MEMU channel, get in touch.",
    colorsGradient2: [ 
        new Vector3(221/255, 159/255, 146/255),
        new Vector3(185/255, 93/255, 85/255)
    ]
}

export default focusChannel